import { createReducer, on, Action } from '@ngrx/store';
import {UIState} from "./ui.model";
import {
  clearMenuState,
  setAppRestricted,
  setLocationPermissions,
  setMenuState, setSoftCheckState
} from "./ui.actions";
import * as _ from 'lodash-es';

export const initialState: UIState = {
  menuSettings: undefined,
  theme: undefined,
  appRestricted: undefined,
  locationPermission: undefined,
  us_state: undefined,
}

const reducer = createReducer(
  initialState,
  on(setMenuState, (state, action) => {
    const currentState = _.cloneDeep(Object.assign({}, state.menuSettings, action.menuState))
    return {
      ...state,
      menuSettings: currentState
    }
  }),
  on(clearMenuState, (state, action) => {
    return {
      ...state,
      menuSettings: undefined
    }
  }),
  on(setAppRestricted, (state, action) => {
    return {
      ...state,
      appRestricted: action.restricted
    }
  }),
  on(setSoftCheckState, (state, action) => {
    return {
      ...state,
      us_state: action.us_state
    }
  }),
  on(setLocationPermissions, (state, action) => {
    return {
      ...state,
      locationPermission: action.location_allowed
    }
  }),
)

export function uiReducer(
  state: UIState | undefined,
  action: Action
) : UIState {
  return reducer(state, action);
}
